import React, {
  useRef,
  useMemo,
  forwardRef,
  useImperativeHandle,
  useCallback,
} from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Typography from "@tiptap/extension-typography";
import TaskList from "@tiptap/extension-task-list";
import TaskItem from "@tiptap/extension-task-item";
import Placeholder from "@tiptap/extension-placeholder";
import TextAlign from "@tiptap/extension-text-align";
import Link from "@tiptap/extension-link";
// import { HexColorDecorator } from '../extensions'
// import { formatHtml, markdownToHtml, htmlToMarkdown } from '../helpers'
// eslint-disable-next-line no-unused-vars
import { formatHtml } from "../helpers";
import { Toolbar } from "./Toolbar";
import "./TipTap.scss";

const Tiptap = forwardRef(
  (
    {
      isFullExtension = false,
      content = "",
      editable = true,
      placeholder = "Nhập dữ liệu...",
      withToolbar = false,
      withTypographyExtension = false,
      withCodeBlockLowlightExtension = false,
      withTaskListExtension = false,
      withPlaceholderExtension = false,
      withLinkExtension = false,
      isAnimate = false,
      actions,
    },
    ref,
  ) => {
    const extensions = useMemo(() => {
      const exts = [
        StarterKit.configure({
          ...(withCodeBlockLowlightExtension && { codeBlock: false }),
        }),
        TextAlign.configure({
          types: ["heading", "paragraph"],
          alignments: ["left", "center", "right", "justify"],
        }),
        Link.configure({
          autolink: false,
        }),
      ];

      if (withTypographyExtension) exts.push(Typography);
      if (withTaskListExtension) exts.push(TaskList, TaskItem);
      if (withLinkExtension) {
        exts.push(Link.configure({ linkOnPaste: true, openOnClick: true }));
      }
      if (withPlaceholderExtension) {
        exts.push(Placeholder.configure({ placeholder }));
      }

      return exts;
    }, [
      withCodeBlockLowlightExtension,
      withTypographyExtension,
      withTaskListExtension,
      withLinkExtension,
      withPlaceholderExtension,
      placeholder,
    ]);

    const editorHtmlContentRef = useRef(
      typeof content === "string" ? content : "",
    );

    const editor = useEditor({
      content,
      extensions,
      editable,
      onUpdate: ({ editor }) => {
        editorHtmlContentRef.current = editor.getHTML();
      },
    });
    const insertData = useCallback(
      (data) => {
        editor.commands.insertContent(data);
      },
      [editor],
    );

    const clearData = useCallback(
      (data) => {
        editor.commands.clearContent();
      },
      [editor],
    );

    useImperativeHandle(
      ref,
      () => ({
        getValue: () => editorHtmlContentRef.current,
        insertData,
        clearData,
      }),
      [clearData, insertData],
    );

    if (!editor) {
      return null;
    }

    return (
      <>
        <div className="WhiteCard">
          {withToolbar ? (
            <Toolbar
              actions={actions}
              editor={editor}
              isFullExtension={isFullExtension}
              isAnimate={isAnimate}
            />
          ) : null}
          <EditorContent
            allowSpaces
            className="content-tiptap"
            editor={editor}
          />
        </div>
      </>
    );
  },
);

export default Tiptap;
